import { action } from 'easy-peasy';
import { IActionDeleteStorageFile } from '../types';

const deleteStorageFile: IActionDeleteStorageFile = action((state, id) => {
  state.items = state.items.filter(item => item.id !== id);
});

export default deleteStorageFile;
